import { c as _c } from "react/compiler-runtime";
import { useSubscribedCoupon } from './useSubscribedCoupon.js';
/**
 * Hook to get the type of a coupon from the coupon store.
 *
 * @param root0 - The coupon identifiers
 * @param root0.couponId - The unique identifier of the coupon
 * @param root0.couponIndex - The index of the coupon in the store
 * @returns The type of the coupon, singlerow, standard, etc.
 */
export function useCouponType(t0) {
  const $ = _c(3);
  const {
    couponId,
    couponIndex
  } = t0;
  let t1;
  if ($[0] !== couponId || $[1] !== couponIndex) {
    t1 = {
      couponId,
      couponIndex,
      selector: _temp
    };
    $[0] = couponId;
    $[1] = couponIndex;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const couponType = useSubscribedCoupon(t1);
  return couponType;
}
function _temp(coupon) {
  if (!coupon) {
    return "standard";
  }
  return coupon.couponType;
}